import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const headerCss = ".sc-owc-header-h{width:100%}";
const OwcHeaderStyle0 = headerCss;
const Header = /*@__PURE__*/proxyCustomElement(class Header extends H {
  constructor() {
    super();
    this.__registerHost();
    this.component = new ComponentUtils(this);
  }
  render() {
    const hostClasses = this.component.getHostBemClasses();
    return h(Host, Object.assign({
      key: '0a2b600a8eb8344fa0f1ef094cefb4757ae7da33',
      class: hostClasses
    }, accessibility({
      role: 'banner'
    })), h("slot", {
      key: 'd186532640f789239ae7d3514eb4a642779f41e9'
    }));
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcHeaderStyle0;
  }
}, [6, "owc-header"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-header"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-header":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Header);
        }
        break;
    }
  });
}
const OwcHeader = Header;
const defineCustomElement = defineCustomElement$1;
export { OwcHeader, defineCustomElement };